import { CheckCircle2, AlertTriangle, XCircle, CircleDashed } from "lucide-react";
import { cn } from "@/lib/utils";

export type StatusType = "pass" | "warn" | "fail" | "na";

interface StatusIconProps {
  status: StatusType;
  size?: "sm" | "md" | "lg";
  className?: string;
  onClick?: () => void;
}

export function StatusIcon({ status, size = "md", className, onClick }: StatusIconProps) {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-5 w-5", 
    lg: "h-6 w-6"
  };

  const statusConfig = {
    pass: {
      icon: CheckCircle2,
      className: "text-status-pass"
    },
    warn: {
      icon: AlertTriangle,
      className: "text-status-warn"
    },
    fail: {
      icon: XCircle,
      className: "text-status-fail"
    },
    na: {
      icon: CircleDashed,
      className: "text-status-na"
    }
  };

  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <Icon 
      className={cn(
        sizeClasses[size],
        config.className,
        className
      )} 
      onClick={onClick}
    />
  );
}